import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import useUpdateVesselDocuments from "../Utils/useUpdateVesselDocuments";
import { FaRegFile } from "react-icons/fa";
import { MdDone } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import "react-toastify/dist/ReactToastify.css";
import "./updatevessel.css";

const UpdateVesselDocumentsForm = ({ vesselId }) => {
  const { mutate: updateVesselDocuments, isLoading: isUpdatingDocuments} = useUpdateVesselDocuments();

  const [specSheet, setSpecSheet] = useState(null);
  const [bollardPullCertificate, setBollardPullCertificate] = useState(null);
  const [navyCertificate, setNavyCertificate] = useState(null);
  const [collapsedSections, setCollapsedSections] = useState({ vesselDocuments: true });
  const [vesselType, setVesselType] = useState("");

  const specSheetRef = useRef();
  const bollardPullCertificateRef = useRef();
  const navyCertificateRef = useRef();

  useEffect(() => {
    const storedVesselType = localStorage.getItem("selectedVesselType");
    if (storedVesselType) {
      setVesselType(storedVesselType);
    }
  }, []);

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    if (name === "specSheet") setSpecSheet(file);
    if (name === "bollardPullCertificate") setBollardPullCertificate(file);
    if (name === "navyCertificate") setNavyCertificate(file);
  };

  const handleRemoveFile = (name) => {
    if (name === "specSheet") setSpecSheet(null);
    if (name === "bollardPullCertificate") setBollardPullCertificate(null);
    if (name === "navyCertificate") setNavyCertificate(null);
  };

  const formatFileSize = (size) => {
    if (size < 1024) return `${size} bytes`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!specSheet) {
      toast.error("Please upload the Spec Sheet.");
      return;
    }
  
    const documents = [{ name: "specSheet", file: specSheet }];
  
    if (vesselType === "AHTS 001" && bollardPullCertificate) {
      documents.push({ name: "bollardPullCertificate", file: bollardPullCertificate });
    }
  
    if (vesselType === "SEV 001" && navyCertificate) {
      documents.push({ name: "navyCertificate", file: navyCertificate });
    }
  
    updateVesselDocuments({ vesselId, documents }, {
      onSuccess: () => {
        toast.success("Vessel documents updated successfully!");
      },
      onError: (error) => {
        toast.error(`Error updating vessel documents: ${error.message}`);
      },
    });
  };
  


  const toggleSection = (section) => {
    setCollapsedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  return (
    <div className="update-vessel-container">
      <div className="pri" onClick={() => toggleSection("vesselDocuments")}>
        <p>Vessel Documents</p>
        {collapsedSections.vesselDocuments ? (
          <IoIosArrowDown />
        ) : (
          <IoIosArrowUp />
        )}
      </div>
      {!collapsedSections.vesselDocuments && (
        <form onSubmit={handleSubmit}>
          {!specSheet && (
            <label>
              Spec Sheet
              <img
                src="https://i.ibb.co/MBfbwGm/Frame-1171277781.png"
                alt="Upload"
              />
              <input
                type="file"
                name="specSheet"
                ref={specSheetRef}
                onChange={handleFileChange}
                 accept=".pdf"
                style={{ display: "none" }}
              />
            </label>
          )}
          {specSheet && (
            <div className="file-preview">
              <div className="first">
                <FaRegFile className="file" />
                <span>
                  {specSheet.name} ({formatFileSize(specSheet.size)})
                </span>
              </div>
              <div className="second">
                <MdDone className="done" />
                <RiDeleteBin6Line
                  onClick={() => handleRemoveFile("specSheet")}
                  className="icon"
                />
              </div>
            </div>
          )}
          {vesselType === "AHTS 001" && (
            <>
              {!bollardPullCertificate && (
                <label>
                  Bollard Pull Certificate
                  <img
                    src="https://i.ibb.co/MBfbwGm/Frame-1171277781.png"
                    alt="Upload"
                  />
                  <input
                    type="file"
                    name="bollardPullCertificate"
                    ref={bollardPullCertificateRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                     accept=".pdf"
                  />
                </label>
              )}
              {bollardPullCertificate && (
                <div className="file-preview">
                  <div className="first">
                    <FaRegFile className="file" />
                    <span>
                      {bollardPullCertificate.name} (
                      {formatFileSize(bollardPullCertificate.size)})
                    </span>
                  </div>
                  <div className="second">
                    <MdDone className="done" />
                    <RiDeleteBin6Line
                      onClick={() => handleRemoveFile("bollardPullCertificate")}
                      className="icon"
                    />
                  </div>
                </div>
              )}
            </>
          )}
          {vesselType === "SEV 001" && (
            <>
              {!navyCertificate && (
                <label>
                  Navy Certificate
                  <img
                    src="https://i.ibb.co/MBfbwGm/Frame-1171277781.png"
                    alt="Upload"
                  />
                  <input
                    type="file"
                    name="navyCertificate"
                    ref={navyCertificateRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                     accept=".pdf"
                  />
                </label>
              )}
              {navyCertificate && (
                <div className="file-preview">
                  <div className="first">
                    <FaRegFile className="file" />
                    <span>
                      {navyCertificate.name} (
                      {formatFileSize(navyCertificate.size)})
                    </span>
                  </div>
                  <div className="second">
                    <MdDone className="done" />
                    <RiDeleteBin6Line
                      onClick={() => handleRemoveFile("navyCertificate")}
                      className="icon"
                    />
                  </div>
                </div>
              )}
            </>
          )}
          <button type="submit" disabled={isUpdatingDocuments}>
            {isUpdatingDocuments ? "Updating..." : "Update Documents"}
          </button>
        </form>
      )}
      <ToastContainer />
    </div>
  );
};

export default UpdateVesselDocumentsForm;
